import styled from 'styled-components/macro';

export const BGContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    img {
        height: 100%;
        object-fit: cover;
    }
`;
